export enum MeteringFilterType {
  MeteringPoint = 'MeteringPoint',
  MeteringPointGroup = 'MeteringPointGroup',
  VirtualFilter = 'VirtualFilter',
  Unfiltered = 'Unfiltered'
}
